import { getModule } from 'vuex-module-decorators';

import { StoreSingleton } from '.';
import EventStore from './event.module';

export const eventStore = getModule<EventStore>(EventStore, StoreSingleton.getInstance());
